import { BoldText } from "components/markdown-text";
import React from "react";
import { View, TouchableOpacity, Text } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { styles } from "./styles";

export const IconButton = props => {
  const { text, icon, onPress, disabled } = props;
  const Wrapper = onPress ? TouchableOpacity : View;
  return (
    <Wrapper
      onPress={onPress}
      disabled={disabled}
      style={[styles.button, disabled && styles.disabled]}
    >
      <Icon
        name={icon}
        color={styles._text?.color}
        size={styles._icon?.fontSize}
      />
      <Text style={styles.text}>
        <BoldText>{text}</BoldText>
      </Text>
    </Wrapper>
  );
};
